export enum RoomTypeEnum {
  Task = 0,
	Chat = 1
}